import { Typography } from "@mui/material";
import Model from "../base/Model/ui";
import { Col, Row } from "../base/Flex/ui";

const TestModel = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Model.Wrapper open={open} onClose={onClose}>
      <Model.Container size="md">
        <Model.Header.Wrapper>
          <Model.Header.Title>
            <Typography variant="mobile-h2">Title</Typography>
          </Model.Header.Title>
          <Model.Header.CloseButton close={onClose} />
        </Model.Header.Wrapper>
        <Model.Content>
          <Row type="cc" fullWidth>
            <Col sx={{ padding: "60px 0" }}>
              <Typography variant="mobile-h1">Content</Typography>
            </Col>
          </Row>
        </Model.Content>
      </Model.Container>
    </Model.Wrapper>
  );
};

export default TestModel;
